import { Component, Input } from '@angular/core';
import { NoticeType, NoticeTypeDto } from '@flyfreely-portal-ui/flyfreely';

@Component({
    selector: 'notice-type-list-item',
    templateUrl: './notice-type-list-item.component.html',
    styleUrl: './notice-type-list-item.component.scss'
})
export class NoticeTypeListItemComponent {
    @Input() noticeType?: NoticeTypeDto | NoticeType;
}
